import React, { useState } from 'react';
import { ChevronLeft, Clock, Check, Sparkles } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { MockProfile } from '../data/mockProfiles';
import { AVAILABLE_SLOTS } from './MeetingRequestsContext';
const FAKE_NAMES: Record<string, string> = {
  p1: 'Marco Rossi',
  p2: 'Laura Bianchi',
  p3: 'Giuseppe Verdi',
  p4: 'Sofia Romano',
  p5: 'Andrea Colombo',
  p6: 'Giulia Ricci',
  p7: 'Matteo Marino',
  p8: 'Chiara Greco',
  p9: 'Alessandro Bruno',
  p10: 'Francesca Gallo',
  p11: 'Lorenzo Conti',
  p12: 'Valentina De Luca',
  p13: 'Davide Costa',
  p14: 'Elena Giordano',
  p15: 'Simone Rizzo',
  p16: 'Martina Lombardi',
  p17: 'Luca Moretti',
  p18: 'Sara Barbieri',
  p19: 'Giovanni Fontana',
  p20: 'Silvia Santoro',
  p21: 'Federico Mariani',
  p22: 'Alessia Rinaldi',
  p23: 'Antonio Caruso',
  p24: 'Elisa Ferrara',
  p25: 'Gabriele Galli'
};
interface Props {
  profile: MockProfile;
  initialSlotId: string;
  onBack: () => void;
}
export function ConnectionReveal({
  profile,
  initialSlotId,
  onBack
}: Props) {
  const {
    t
  } = useLanguage();
  const [selectedSlot, setSelectedSlot] = useState<string>(initialSlotId);
  const name = FAKE_NAMES[profile.id] || 'Utente';
  const photoUrl = `https://randomuser.me/api/portraits/${parseInt(profile.id.replace('p', ''), 10) % 2 === 0 ? 'women' : 'men'}/${parseInt(profile.id.replace('p', ''), 10)}.jpg`;
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] relative animate-in fade-in duration-300" data-id="element-62">
      <div className="flex-1 overflow-y-auto px-6 pt-5 pb-8" data-id="element-63">
        <button onClick={onBack} aria-label={t('common.back')} className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full active:bg-[#141414] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C5D82D]" data-id="element-64">
          <ChevronLeft className="w-6 h-6 text-white" strokeWidth={2} data-id="element-65" />
        </button>

        <div className="flex flex-col items-center text-center mt-2 mb-8" data-id="element-66">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#C5D82D]/15 text-[#C5D82D] text-[11px] font-semibold mb-6" data-id="element-67">
            <Sparkles className="w-3.5 h-3.5" strokeWidth={2} data-id="element-68" />
            Connessione confermata!
          </div>

          <div className="w-24 h-24 rounded-full bg-[#2A2A2A] shrink-0 overflow-hidden relative mb-4 border-2 border-[#C5D82D]" data-id="element-69">
            <img src={photoUrl} alt={name} className="w-full h-full object-cover" data-id="element-70" />
          </div>

          <h1 className="text-[22px] text-white font-semibold mb-1" data-id="element-71">{name}</h1>
          <p className="text-[14px] text-[#C5D82D] font-medium mb-1" data-id="element-72">
            {profile.role}
          </p>
          <p className="text-[13px] text-[#A0A0A0]" data-id="element-73">{profile.sector}</p>
        </div>

        <div className="bg-[#141414] border border-[#2A2A2A] rounded-[16px] p-5" data-id="element-74">
          <h3 className="text-[13px] text-white font-medium mb-4 flex items-center gap-2" data-id="element-75">
            <Clock className="w-4 h-4 text-[#C5D82D]" data-id="element-76" />
            Slot preferiti per l'incontro
          </h3>
          <div className="flex flex-col gap-2.5" data-id="element-77">
            {AVAILABLE_SLOTS.map(slot => {
            const isSelected = selectedSlot === slot.id;
            return <button key={slot.id} onClick={() => setSelectedSlot(slot.id)} className={`flex items-center justify-between p-3 rounded-xl border transition-all ${isSelected ? 'bg-[#C5D82D]/10 border-[#C5D82D] text-white' : 'bg-[#1A1A1A] border-[#2A2A2A] text-[#A0A0A0] hover:border-[#444444]'}`} data-id="element-78">
                  <div className="flex flex-col items-start" data-id="element-79">
                    <span className={`text-[13px] font-medium ${isSelected ? 'text-white' : 'text-[#CCCCCC]'}`} data-id="element-80">
                      {t(slot.dayKey)}
                    </span>
                    <span className="text-[11px] mt-0.5" data-id="element-81">
                      {t(slot.timeKey)}
                    </span>
                  </div>
                  <div className={`w-5 h-5 rounded-full border flex items-center justify-center ${isSelected ? 'border-[#C5D82D] bg-[#C5D82D]' : 'border-[#444444]'}`} data-id="element-82">
                    {isSelected && <Check className="w-3 h-3 text-[#0D0D0D]" strokeWidth={3} data-id="element-83" />}
                  </div>
                </button>;
          })}
          </div>
        </div>
      </div>

      <div className="shrink-0 bg-[#0D0D0D]/95 backdrop-blur-xl border-t border-[#1A1A1A] px-6 pt-4 pb-24 z-30" data-id="element-84">
        <button onClick={onBack} className="w-full py-4 rounded-full text-[14px] font-semibold tracking-wide bg-[#C5D82D] text-[#0D0D0D] active:scale-[0.98] transition-transform" data-id="element-85">
          Conferma incontro
        </button>
      </div>
    </div>;
}